module.exports = __webpack_public_path__ + "static/media/soviet_flotilla_120x120.5eb812f7.png";